import { render } from "./IgrnIndex.vue?vue&type=template&id=7e59add8&scoped=true"
import script from "./IgrnIndex.vue?vue&type=script&lang=js"
export * from "./IgrnIndex.vue?vue&type=script&lang=js"

import "./IgrnIndex.vue?vue&type=style&index=0&id=7e59add8&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e59add8"]])

export default __exports__